import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import classes from "./sparesVariantForm.module.css";
import { FormInput } from "../../../../shared/formElements/formInput/FormInput";
import { FormImagePreviewAndUpload } from "../../../../shared/formElements/FormImagePreviewAndUpload/FormImagePreviewAndUpload";
import { FormDynamicStringList } from "../../../../shared/formElements/formDynamicStringList/FormDynamicStringList";
import { FormDynamicKeyValueList } from "../../../../shared/formElements/formDynamicKeyValueList/FormDynamicKeyValueList";


export const SparesVariantForm = ({
  initialValues,
  isEditMode,
  onSubmit,
  onDelete,
  isSubmitting,
  isDeleting,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    control,
    setValue,
    formState: { isValid, errors },
  } = useForm({
    defaultValues: initialValues,
    mode: "onChange",
  });

  useEffect(() => {
    reset(initialValues);
  }, [initialValues, reset]);

  const spareImageUrl = watch("spare_image");

  return (
    <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
      {/* -------------------- VARIANT BASIC INFO -------------------- */}
      <div className={classes.section}>
        <h3 className={classes.sectionTitle}>Variant Information</h3>
        <div className={classes.grid}>
          <FormInput
            id="brand"
            label="Brand"
            register={register}
            required={true}
            validation={{ required: "Brand is required" }}
            error={errors.brand?.message}
          />
          <FormInput
            id="model"
            label="Model"
            register={register}
            required={true}
            validation={{ required: "Model is required" }}
            error={errors.model?.message}
          />
          <FormInput
            id="color"
            label="Color"
            register={register}
            required={true}
            validation={{ required: "Color is required" }}
            error={errors.color?.message}
          />
          <FormInput
            id="part_name"
            label="Part Name"
            register={register}
            required={true}
            validation={{ required: "Part Name is required" }}
            error={errors.part_name?.message}
          />
          <FormInput
            id="price"
            label="Price"
            register={register}
            required={true}
            validation={{ required: "Price is required" }}
            error={errors.price?.message}
          />
          <FormInput
            id="original_price"
            label="Original Price"
            register={register}
            required={true}
            validation={{ required: "Original Price is required" }}
            error={errors.original_price?.message}
          />
        </div>
      </div>

      {/* -------------------- SPARE IMAGE -------------------- */}
      <div className={classes.section}>
        <h3 className={classes.sectionTitle}>Spare Image</h3>
        <FormImagePreviewAndUpload
          id="spare_image"
          url={spareImageUrl}
          register={register}
          setValue={setValue}
          uploadType="test"
          extraParams={{
            brand_name: initialValues.brand,
            model_name: initialValues.model,
            part_name: initialValues.part_name,
            color_name: initialValues.color,
            no: "1",
          }}
          validation={{ required: "Image is required" }}
          error={errors.spare_image?.message}
        />
      </div>

      {/* -------------------- STRING LISTS -------------------- */}
      <div className={classes.section}>
        <h3 className={classes.sectionTitle}>About This Item</h3>
        <FormDynamicStringList
          register={register}
          watch={watch}
          setValue={setValue}
          fieldName="about_this_item"
          control={control}
          required={true}
          errors={errors.about_this_item}
        />
      </div>

      <div className={classes.section}>
        <h3 className={classes.sectionTitle}>Product Details</h3>
        <FormDynamicStringList
          register={register}
          watch={watch}
          setValue={setValue}
          fieldName="product_details"
          control={control}
          required={true}
          errors={errors.product_details}
        />
      </div>

      {/* -------------------- KEY-VALUE LISTS -------------------- */}
      <div className={classes.section}>
        <h3 className={classes.sectionTitle}>Specifications</h3>
        <FormDynamicKeyValueList
          register={register}
          watch={watch}
          setValue={setValue}
          fieldName="specifications"
          control={control}
          required={true}
          errors={errors.specifications}
        />
      </div>

      <div className={classes.section}>
        <h3 className={classes.sectionTitle}>FAQs</h3>
        <FormDynamicKeyValueList
          register={register}
          watch={watch}
          setValue={setValue}
          fieldName="FAQs"
          control={control}
          required={true}
          errors={errors.FAQs}
        />
      </div>

      {/* -------------------- ACTION BUTTONS -------------------- */}
      <div className={classes.actions}>
        {isEditMode && (
          <button
            type="button"
            className={classes.deleteBtn}
            onClick={onDelete}
            disabled={isDeleting}
          >
            {isDeleting ? "Deleting..." : "Delete"}
          </button>
        )}

        <button
          className={classes.submitBtn}
          type="submit"
          disabled={isSubmitting || !isValid}
        >
          {isSubmitting
            ? isEditMode
              ? "Updating..."
              : "Adding..."
            : isEditMode
            ? "Update Variant"
            : "Add Variant"}
        </button>
      </div>
    </form>
  );
};
